import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyCheckbox } from './ly-checkbox/ly-checkbox.component';
import { LyCheckboxService } from './ly-checkbox.service';
var LyCheckboxModule = /** @class */ (function () {
    function LyCheckboxModule() {
    }
    LyCheckboxModule.forRoot = function () {
        return {
            ngModule: LyCheckboxModule,
        };
    };
    LyCheckboxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [LyCheckbox],
                    declarations: [LyCheckbox],
                    providers: [LyCheckboxService]
                },] },
    ];
    /** @nocollapse */
    LyCheckboxModule.ctorParameters = function () { return []; };
    return LyCheckboxModule;
}());
export { LyCheckboxModule };
//# sourceMappingURL=ly-checkbox.module.js.map